/**
 * Anteprima dati azienda: chiama flusia-core e, se non risponde, ripiega sulla
 * edge function `lead-enrich-preview`, che resta attiva proprio per questo.
 * Stesso schema di degradazione usato per le email transazionali.
 */
import { coreCall } from '../services/gatewayService';
import { supabase } from '../supabase';

export interface ProspectPreviewResponse {
  website: Record<string, unknown> | null;
  vies: Record<string, unknown> | null;
  cached?: boolean;
}

const EMPTY: ProspectPreviewResponse = { website: null, vies: null };

export async function fetchProspectPreview(args: {
  websites: string[];
  vatNumber?: string | null;
  signal?: AbortSignal;
}): Promise<ProspectPreviewResponse> {
  const websites = args.websites.filter(Boolean);
  const vatNumber = args.vatNumber || null;
  if (websites.length === 0 && !vatNumber) return EMPTY;
  if (args.signal?.aborted) return EMPTY;

  const body = { websites, vat_number: vatNumber, domain: websites[0] || null };

  const core = await coreCall<ProspectPreviewResponse>('enrichment/prospect-preview', { body });
  if (!core.error && core.data) return core.data;
  if (args.signal?.aborted) return EMPTY;

  // Ripiego: la edge function accetta un solo sito per chiamata.
  const edge = await supabase.functions.invoke('lead-enrich-preview', {
    body: { website: websites[0] || undefined, vat_number: vatNumber || undefined },
  });
  if (edge.error || !edge.data) return EMPTY;

  const d = edge.data as Record<string, unknown>;
  return {
    website: (d.website as Record<string, unknown>) || null,
    vies: (d.vies as Record<string, unknown>) || null,
  };
}
